import { User } from '../models/user';
import * as users from '../actions/users.actions';

export interface State {
  users: User[];
  isFetching: boolean;
  fetchError: any;
}

export const initialState: any = {
  isFetching: false,
  users: [],
  fetchError: null
};


export function reducer(state: State = initialState, action: users.Actions): State {

  switch (action.type) {

    case users.FETCH_USERS:
      return Object.assign({}, state, { isFetching: true });

    case users.FETCH_USERS_SUCCESS:
      return Object.assign({}
        , state
        , { users: action.payload, isFetching: false, fetchError: false });

    case users.FETCH_USERS_FAILURE:
      return Object.assign({}
        , state
        , { isFetching: false, fetchError: action.payload });

    case users.ADD_USER:
      return Object.assign({}, state, { isFetching: true });

    case users.ADD_USER_SUCCESS:
      let newUsers = [...state.users, action.payload.user];
      return Object.assign({}
        , state
        , { users: newUsers, isFetching: false, fetchError: false });

    case users.ADD_USER_FAILURE:
      return Object.assign({}
        , state
        , { isFetching: false, fetchError: action.payload });

    case users.DELETE_USER:
      return Object.assign({}, state, { isFetching: true });

    case users.DELETE_USER_SUCCESS:
      let newUsersAfterDelete = state.users.filter(u => u['_id'] !== action.payload.id);
      return Object.assign({}
        , state
        , { users: newUsersAfterDelete, isFetching: false, fetchError: false });

    case users.DELETE_USER_FAILURE:
      return Object.assign({}
        , state
        , { isFetching: false, fetchError: action.payload });
    default:
      return state;
  }
}
export const getUsers = (state: State) => state.users;




// WEBPACK FOOTER //
// ./src/reducers/users.reducer.ts